import { useEffect, useContext } from "react"
import { useParams } from 'react-router-dom';
import { UserContext } from "../../../context/userContext"
import { useFormikContext } from "formik"

import styles from "../../../styles/Form.module.css"

export default function Owner({ field, block, index }) {
  const { type } = useParams();
  const isEnterprise = type === 'enterprise'
  const userCtx = useContext(UserContext)

  const formik = useFormikContext()

  useEffect(() => {
    if(isEnterprise) {
        return formik.setFieldValue(field.field_name, userCtx.session.user.enterprise_id)
    } else {
        return formik.setFieldValue(field.field_name, userCtx.session.user.organization_id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <div className={styles.hidden} style={{ order: index }}>
      <input
        type="hidden"
        name={field.field_name}
        value={formik.values[field.field_name]}
      />
    </div>
  )
}